import { FC } from "react";
import { Datagrid, List, ReferenceField, TextField } from "react-admin";

import CustomPagination from "../../components/CustomPagination";
import EmptyDataText from "../../components/EmptyDataText";
import TimestampField from "../../components/TimestampField";
import useCurrentUser from "../../hooks/useCurrentUser";
import useIsAdmin from "../../hooks/useIsAdmin";
import useIsSportsClub from "../../hooks/useIsSportsClub";
import useUpdateListNotifications from "../../hooks/useUpdateListNotifications";
import { AppResource } from "../../types/resource.types";
import { sportClubDocRef } from "../../utils/referencies";
import CancelReservation from "./components/CourtsReservationsActions/CancelReservation";
import ReservationsFilters from "./components/CourtsReservationsFilter";
import ReservationPrice from "./components/ReservationPrice";
import ReservationsStatusText from "./components/ReservationsStatusText";
import ReservationsTime from "./components/ReservationsTime";

const CourtsReservationsList: FC<any> = (props) => {
  const { isSportsClub } = useIsSportsClub();
  const { isAdmin } = useIsAdmin();
  const { user } = useCurrentUser();

  useUpdateListNotifications(
    sportClubDocRef(user.id as string),
    AppResource.courtsReservations,
    AppResource.reservationLastSeenAt
  );

  return (
    <List
      {...props}
      sort={{ field: "createdAt", order: "desc" }}
      pagination={<CustomPagination />}
      bulkActionButtons={false}
      filters={<ReservationsFilters isSportsClub={isSportsClub} isAdmin={isAdmin} userId={user.id} />}
      exporter={false}
    >
      <Datagrid empty={<EmptyDataText message="No reservations yet!" />}>
        <ReferenceField
          label="Client"
          source="clientId"
          reference={`${AppResource.clients}`}
          sortable={false}
          link={false}
        >
          <TextField source="displayName" />
        </ReferenceField>
        <ReferenceField
          label="Phone"
          source="clientId"
          reference={`${AppResource.clients}`}
          sortable={false}
          link={false}
        >
          <TextField source="phoneNumber" />
        </ReferenceField>
        <ReferenceField
          label="Court"
          source="courtId"
          reference={`${AppResource.courts}`}
          sortable={false}
          link={false}
        >
          <TextField source="name.en" />
        </ReferenceField>
        {isAdmin ? (
          <ReferenceField
            label="Club"
            source="sportClubId"
            reference={`${AppResource.sportsClubs}`}
            sortable={false}
            link={false}
          >
            <TextField source="displayName.en" />
          </ReferenceField>
        ) : null}
        <TextField source="paymentMethod" />
        <ReservationPrice label="Price" />
        <ReservationsTime source="firstSlotTime" label="Reservation Time" />
        <TimestampField source="createdAt" label="Created At" />
        <ReservationsStatusText source="status" label="Status" sortable={false} />
        {isSportsClub ? <CancelReservation /> : null}
      </Datagrid>
    </List>
  );
};

export default CourtsReservationsList;
